import { defineStore } from 'pinia';
import { ref } from 'vue';
import { GetWebSettings } from '../services/WebSettings/GetWebSettings.js';
import { WebSettingsInterface } from '../types/webSettingsInterface.js';

export const useWebSettingsStore = defineStore('webSettings', () => {
  const webSettings = ref<WebSettingsInterface[]>([]);

  const getWebSettings = async () => {
    webSettings.value = await GetWebSettings();
  };

  const getSignalRUrl = (settingName: string) => {
    const url = webSettings.value.find((el) => el.name === settingName).value;
    return `${url}/api`;
  };

  return {
    webSettings,
    getWebSettings,
    getSignalRUrl,
  };
});
